import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/Edit';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import { useNavigate } from '@tanstack/react-router';
import type React from 'react';
import viewStateVar from 'src/store/viewState';
import type { FieldMapConfig } from '../types';
import styles from './MetadataFieldMapsItemStyles';

interface MetadataFieldMapsItemProps {
  item: FieldMapConfig;
}

const MetadataFieldMapsItem: React.FC<MetadataFieldMapsItemProps> = ({ item }) => {
  const classes = styles();
  const navigate = useNavigate();

  const editFieldItemHandler = (selectedEditItemId: string, selectedEditItemName: string): void => {
    viewStateVar({
      ...viewStateVar(),
      editFieldMapsId: selectedEditItemId,
      editFieldMapsName: selectedEditItemName,
    });
    navigate({ to: `/systemadmin/metadata/field-maps/edit/${item.id}` });
  };

  const openDeleteFieldMapsModal = (deleteFieldMapsConfigId: string, deleteFieldMapsConfigName: string): void => {
    viewStateVar({
      ...viewStateVar(),
      fieldMapsDeleteDialog: true,
      deleteFieldMapsConfigId: deleteFieldMapsConfigId,
      deleteFieldMapsConfigName: deleteFieldMapsConfigName,
    });
  };

  return (
    <TableRow>
      <TableCell>
        <div>{item.name}</div>
      </TableCell>
      <TableCell>
        <div className={classes.actionButtons}>
          <div className={classes.editButton}>
            <EditIcon
              onClick={() => editFieldItemHandler(item.id, item.name)}
              color="primary"
              style={{ marginTop: '5px', cursor: 'pointer' }}
            />
          </div>
          <div className={classes.deleteButton}>
            <DeleteForeverIcon
              sx={{ color: 'error.main', marginTop: '5px', cursor: 'pointer' }}
              onClick={() => openDeleteFieldMapsModal(item.id, item.name)}
            />
          </div>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default MetadataFieldMapsItem;
